// extracted by mini-css-extract-plugin
export default {"addRemoveOperatorActionTab":"addRemoveOperatorActionTab-mMykH","icon":"icon-MIB8c","select":"select-Zs1gE","table":"table-Btk6A","deleteIcon":"deleteIcon-SHu5H"};